/*eslint-disable*/
import { useNavigate } from "react-router-dom";
import "../assets/styles/satHome.css";
import ImageHours from "../assets/images/hours.jpg";
const SATHome = () => {
  const navigate = useNavigate();
  const handleClickTrainings = () => {
    navigate("/trainings");
  };
  const handleClickAchievements = () => {
    navigate("/achievements");
  };
  const handleClickSchedules = () => {
    navigate("/schedules");
  };

  return (
    <div className="sat-page">
      <img src={ImageHours} style={{}} alt="Hours" />

      <div className="satimage-container">
        <div className="satcontent">
          <div className="button-row">
            <button className="button" onClick={handleClickTrainings}>
              Trainings
            </button>
            <button className="button" onClick={handleClickAchievements}>
              Achievements
            </button>
            <button className="button" onClick={handleClickSchedules}>
              Schedules
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SATHome;
//SAT - Schedules, Achievements and Trainings
